import { render, staticRenderFns } from "./ConfirmLeadDialog.vue?vue&type=template&id=b4c8bda4&scoped=true"
import script from "./ConfirmLeadDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmLeadDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLeadDialog.vue?vue&type=style&index=0&id=b4c8bda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8bda4",
  null
  
)

export default component.exports